import { AST } from '@handlebars/parser';
import { createPathExpression } from 'modules/handlebars/domain/expression/utils';
import { createNullLiteral } from 'modules/handlebars/domain/literal';
import { createHash } from 'modules/handlebars/domain/hash/utils';
import { createSubExpression } from 'modules/handlebars/domain/expression/utils/createSubExpression';

import { comparatorToConditionalHandlebarMacro } from '../../constants';
import { Condition } from '../../domain';

export const createSubExpressionsFromConditons = (conditions: Condition[]): AST.SubExpression[] =>
  conditions.map(({ fieldName, value, comparator }) => {
    const handlebarMacro = comparatorToConditionalHandlebarMacro[comparator];
    const path = createPathExpression(handlebarMacro);
    const hash = createHash();
    const params = [createPathExpression(fieldName), value?.toExpression() ?? createNullLiteral()];
    return createSubExpression({ path, hash, params });
  });
